// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AvailableConversationContext"]);
}

function unwrap_fragment_AvailableConversationContext_context(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["BuyerNeedV5"]);
}

var fragmentConverter = {"__root":{"AvailableConversationContext_context":{"u":"fragment_AvailableConversationContext_context"},"":{"u":"fragment"}}};

var fragmentConverterMap = {
  fragment_AvailableConversationContext_context: unwrap_fragment_AvailableConversationContext_context,
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function forSalePropertyMatchingType_decode($$enum) {
  if ($$enum === "QUIET" || $$enum === "ONE_WAY" || $$enum === "BROADCAST" || $$enum === "QUIET_ANONYMOUS") {
    return $$enum;
  }
  
}

function forSalePropertyMatchingType_fromString(str) {
  return forSalePropertyMatchingType_decode(str);
}

var Utils = {
  forSalePropertyMatchingType_decode: forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: forSalePropertyMatchingType_fromString
};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationPageNotAnonymousWarning_conversationContext",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "context",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": (v1/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "includeOnlyActive",
                          "value": true
                        }
                      ],
                      "concreteType": "BuyerNeedCurrentUserMatchesConnection",
                      "kind": "LinkedField",
                      "name": "currentUsersMatches",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerNeedCurrentUserMatchesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "MatchForForSalePropertyV5",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyV5",
                                        "kind": "LinkedField",
                                        "name": "source",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Seller",
                                            "kind": "LinkedField",
                                            "name": "client",
                                            "plural": false,
                                            "selections": (v1/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "forSalePropertyMatchingType",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "matchingType",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      "action": "NONE"
                                    }
                                  ],
                                  "storageKey": null
                                },
                                "action": "NONE"
                              }
                            ],
                            "storageKey": null
                          },
                          "action": "NONE"
                        }
                      ],
                      "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                    },
                    "action": "NONE"
                  }
                ],
                "type": "BuyerNeedV5",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "type": "AvailableConversationContext",
      "abstractKey": null
    }
  ],
  "type": "ContextForConversation",
  "abstractKey": "__isContextForConversation"
};
})());

var wrap_fragment = RescriptRelay_Internal.wrapUnion;

var wrap_fragment_AvailableConversationContext_context = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.unwrap_fragment_AvailableConversationContext_context = unwrap_fragment_AvailableConversationContext_context;
exports.wrap_fragment_AvailableConversationContext_context = wrap_fragment_AvailableConversationContext_context;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
